module.exports = __webpack_public_path__ + "static/media/arabnet.38cda45b.png";